import styles from "../Reciept/Reciept.module.css"

export default function FNota({ data, printRef }) {
    return (
        <div ref={printRef} className={styles.receipt}>
            {data.rows.map((row, i) => (
                <div
                    key={i}
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "2px",
                    }}
                >
                    {row.map((item, j) => {
                        // Handle line feeds
                        if (item.lf) {
                            return (
                                <div key={j} style={{ width: "100%", height: `${item.lf * 10}px` }}></div>
                            );
                        }

                        return (
                            <div
                                key={j}
                                style={{
                                    flex: item.weight ? item.weight : 1,
                                    fontSize: `${item.size}px`,
                                    textAlign: item.align || "left",
                                    fontWeight: item.weight && parseFloat(item.weight) > 0.8 ? "bold" : "normal",
                                }}
                            >
                                {item.text}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}
